import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ApiRequestDispatcherService {
    public constructor(
        private _http: HttpClient
    ) {
    }

    public get<TResult>(url: string, params?: Record<string, string | Array<string>>): Observable<TResult> {
        return this._http.get<TResult>(url, { params: params });
    }

    public post<TResult>(url: string, body: any): Observable<TResult> {
        return this._http.post<TResult>(url, body);
    }
}
